import axios from 'axios'
import qs from 'qs'

const axiosInstance = axios.create({
    baseURL: '/services/plugin-points-of-interest/points/v2',
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
})

export const getPointsByPerspective = (perspectives: any[]) => {
    return axiosInstance.get('/', {
        params: { perspectiveId: perspectives },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        }
    })
}

export const getPointsByGroup = (groups: any[]) => {
    return axiosInstance.get('/', {
        params: { groupId: groups },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        }
    })
}

export const getPoints = (ids: number) => {
    return axiosInstance.get('/', {
        params: { ids },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        }
    })
}
